import React, { useState, useEffect } from 'react';
import { Send } from 'lucide-react';
import { Button } from './ui/button';
import { getCountryInfo, handleFormSubmission } from '../services/api';

const CTASection = () => {
  const [formData, setFormData] = useState({
    name: '',
    countryCode: '+1',
    phone: '',
    email: '',
    message: ''
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [apiError, setApiError] = useState('');

  // Country codes with their phone number lengths
  const countryCodes = [
    { code: '+1', country: 'US', flag: '🇺🇸', length: 10, name: 'United States' },
    { code: '+1', country: 'CA', flag: '🇨🇦', length: 10, name: 'Canada' },
    { code: '+44', country: 'GB', flag: '🇬🇧', length: 10, name: 'United Kingdom' },
    { code: '+91', country: 'IN', flag: '🇮🇳', length: 10, name: 'India' },
    { code: '+61', country: 'AU', flag: '🇦🇺', length: 9, name: 'Australia' },
    { code: '+92', country: 'PK', flag: '🇵🇰', length: 10, name: 'Pakistan' },
    { code: '+86', country: 'CN', flag: '🇨🇳', length: 11, name: 'China' },
    { code: '+81', country: 'JP', flag: '🇯🇵', length: 10, name: 'Japan' },
    { code: '+49', country: 'DE', flag: '🇩🇪', length: 10, name: 'Germany' },
    { code: '+33', country: 'FR', flag: '🇫🇷', length: 9, name: 'France' },
    { code: '+39', country: 'IT', flag: '🇮🇹', length: 10, name: 'Italy' },
    { code: '+34', country: 'ES', flag: '🇪🇸', length: 9, name: 'Spain' },
    { code: '+52', country: 'MX', flag: '🇲🇽', length: 10, name: 'Mexico' },
    { code: '+55', country: 'BR', flag: '🇧🇷', length: 11, name: 'Brazil' },
    { code: '+27', country: 'ZA', flag: '🇿🇦', length: 9, name: 'South Africa' },
    { code: '+971', country: 'AE', flag: '🇦🇪', length: 9, name: 'UAE' },
    { code: '+31', country: 'NL', flag: '🇳🇱', length: 9, name: 'Netherlands' },
    { code: '+966', country: 'SA', flag: '🇸🇦', length: 9, name: 'Saudi Arabia' },
    { code: '+20', country: 'EG', flag: '🇪🇬', length: 10, name: 'Egypt' },
    { code: '+234', country: 'NG', flag: '🇳🇬', length: 10, name: 'Nigeria' },
    { code: '+254', country: 'KE', flag: '🇰🇪', length: 10, name: 'Kenya' },
    { code: '+7', country: 'RU', flag: '🇷🇺', length: 10, name: 'Russia' },
    { code: '+90', country: 'TR', flag: '🇹🇷', length: 10, name: 'Turkey' },
    { code: '+82', country: 'KR', flag: '🇰🇷', length: 10, name: 'South Korea' },
    { code: '+66', country: 'TH', flag: '🇹🇭', length: 9, name: 'Thailand' },
    { code: '+60', country: 'MY', flag: '🇲🇾', length: 9, name: 'Malaysia' },
    { code: '+65', country: 'SG', flag: '🇸🇬', length: 8, name: 'Singapore' },
    { code: '+63', country: 'PH', flag: '🇵🇭', length: 10, name: 'Philippines' },
    { code: '+62', country: 'ID', flag: '🇮🇩', length: 10, name: 'Indonesia' },
    { code: '+84', country: 'VN', flag: '🇻🇳', length: 9, name: 'Vietnam' },
    { code: '+880', country: 'BD', flag: '🇧🇩', length: 10, name: 'Bangladesh' },
    { code: '+32', country: 'BE', flag: '🇧🇪', length: 9, name: 'Belgium' },
    { code: '+46', country: 'SE', flag: '🇸🇪', length: 9, name: 'Sweden' },
    { code: '+47', country: 'NO', flag: '🇳🇴', length: 8, name: 'Norway' },
    { code: '+45', country: 'DK', flag: '🇩🇰', length: 8, name: 'Denmark' },
    { code: '+358', country: 'FI', flag: '🇫🇮', length: 9, name: 'Finland' },
    { code: '+48', country: 'PL', flag: '🇵🇱', length: 9, name: 'Poland' },
    { code: '+30', country: 'GR', flag: '🇬🇷', length: 10, name: 'Greece' },
    { code: '+351', country: 'PT', flag: '🇵🇹', length: 9, name: 'Portugal' },
    { code: '+420', country: 'CZ', flag: '🇨🇿', length: 9, name: 'Czech Republic' },
    { code: '+43', country: 'AT', flag: '🇦🇹', length: 10, name: 'Austria' },
    { code: '+41', country: 'CH', flag: '🇨🇭', length: 9, name: 'Switzerland' },
    { code: '+353', country: 'IE', flag: '🇮🇪', length: 9, name: 'Ireland' },
    { code: '+64', country: 'NZ', flag: '🇳🇿', length: 9, name: 'New Zealand' },
    { code: '+54', country: 'AR', flag: '🇦🇷', length: 10, name: 'Argentina' },
    { code: '+56', country: 'CL', flag: '🇨🇱', length: 9, name: 'Chile' },
    { code: '+57', country: 'CO', flag: '🇨🇴', length: 10, name: 'Colombia' },
    { code: '+51', country: 'PE', flag: '🇵🇪', length: 9, name: 'Peru' },
    { code: '+58', country: 'VE', flag: '🇻🇪', length: 10, name: 'Venezuela' },
    { code: '+972', country: 'IL', flag: '🇮🇱', length: 9, name: 'Israel' }
  ];

  // Fetch country info and auto-select dial code on component mount
  useEffect(() => {
    const loadCountryInfo = async () => {
      try {
        const countryInfo = await getCountryInfo();
        if (countryInfo && countryInfo.dialCode) {
          setFormData(prev => ({ ...prev, countryCode: countryInfo.dialCode }));
        }
      } catch (error) {
        console.error('Error loading country info:', error);
        // Silently fail - form will use default +1
      }
    };
    
    loadCountryInfo();
  }, []);

  const validatePhone = (phone, countryCode) => {
    const cleanPhone = phone.replace(/\D/g, '');
    // Phone must have at least 7 digits
    if (cleanPhone.length < 7) return false;
    
    const selectedCountry = countryCodes.find(c => c.code === countryCode);
    if (!selectedCountry) {
      // If country not in list, accept 7-15 digit numbers
      return cleanPhone.length >= 7 && cleanPhone.length <= 15;
    }
    // Check exact length for known countries
    return cleanPhone.length === selectedCountry.length;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    const newErrors = {};
    
    if (!formData.name.trim()) {
      newErrors.name = 'Name is required';
    }
    
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!validatePhone(formData.phone, formData.countryCode)) {
      const selectedCountry = countryCodes.find(c => c.code === formData.countryCode);
      if (selectedCountry) {
        newErrors.phone = `Phone number must be ${selectedCountry.length} digits for ${selectedCountry.name}`;
      } else {
        newErrors.phone = 'Invalid phone number';
      }
    }
    
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }
    
    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }
    
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    
    // Clear previous errors
    setApiError('');
    setIsSubmitting(true);
    
    // Add default package info
    const submitData = {
      ...formData,
      packageTitle: 'Basic',
      packageAmount: '45'
    };
    
    // Submit to API
    await handleFormSubmission(
      submitData,
      (result) => {
        // Success callback
        console.log('CTA form submitted successfully:', result);
        setSubmitSuccess(true);
        setIsSubmitting(false);
        // Redirect happens automatically in handleFormSubmission
      },
      (error) => {
        // Error callback
        console.error('CTA form submission error:', error);
        setApiError(error);
        setIsSubmitting(false);
      }
    );
  };

  return (
    <div className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Ready to Protect Your Brand?
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Fill out the form below and our trademark experts will get back to you within 24 hours
          </p>
        </div>

        {/* API Error Display */}
        {apiError && !submitSuccess && (
          <div className="bg-red-500/10 border border-red-500 text-red-300 px-4 py-3 rounded-lg mb-4 text-center max-w-2xl mx-auto">
            <p className="text-sm">{apiError}</p>
          </div>
        )}

        {submitSuccess && (
          <div className="bg-[#168356] text-white px-6 py-3 rounded-lg mb-6 text-center max-w-2xl mx-auto">
            ✓ Thank you! We'll contact you within 24 hours.
          </div>
        )}

        {/* Single Row Form */}
        <form onSubmit={handleSubmit} className="w-full">
          {/* Desktop: Single Row */}
          <div className="hidden min-[665px]:flex flex-row gap-3 mb-3 items-start">
            {/* Name Field */}
            <div className="flex-1">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={`w-full h-12 px-4 py-3 bg-white/10 border ${errors.name ? 'border-red-500' : 'border-white/20'} rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all`}
                placeholder="Your Name *"
              />
              {errors.name && <p className="text-red-400 text-xs mt-1">{errors.name}</p>}
            </div>

            {/* Phone Field with Country Code */}
            <div className="flex-1">
              <div className="flex">
                <select
                  name="countryCode"
                  value={formData.countryCode}
                  onChange={handleChange}
                  className="w-24 h-12 px-2 py-3 bg-white/10 border border-white/20 rounded-l-lg rounded-r-none border-r-0 text-white text-sm focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all"
                >
                  {countryCodes.map((country, idx) => (
                    <option key={idx} value={country.code} className="bg-gray-900">
                      {country.flag} {country.code}
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className={`flex-1 w-full h-12 px-4 py-3 bg-white/10 border ${errors.phone ? 'border-red-500' : 'border-white/20'} rounded-r-lg rounded-l-none text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all`}
                  placeholder="Phone Number *"
                />
              </div>
              {errors.phone && <p className="text-red-400 text-xs mt-1">{errors.phone}</p>}
            </div>

            {/* Email Field */}
            <div className="flex-1">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`w-full h-12 px-4 py-3 bg-white/10 border ${errors.email ? 'border-red-500' : 'border-white/20'} rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all`}
                placeholder="Your Email *"
              />
              {errors.email && <p className="text-red-400 text-xs mt-1">{errors.email}</p>}
            </div>

            {/* Message Field */}
            <div className="flex-1">
              <input
                type="text"
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className={`w-full h-12 px-4 py-3 bg-white/10 border ${errors.message ? 'border-red-500' : 'border-white/20'} rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all`}
                placeholder="Your Message *"
              />
              {errors.message && <p className="text-red-400 text-xs mt-1">{errors.message}</p>}
            </div>

            {/* Submit Button */}
            <div>
              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full lg:w-auto h-12 bg-gradient-to-r from-[#168356] to-[#0a5938] hover:from-[#0a5938] hover:to-[#168356] text-white font-bold px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#168356]/30 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? 'Submitting...' : (
                  <>
                    Start Registration <Send className="w-4 h-4 ml-2 inline" />
                  </>
                )}
              </Button>
            </div>
          </div>

          {/* Mobile: Stacked 100% width fields */}
          <div className="max-[664px]:block hidden mb-3">
            {/* Name Field */}
            <div className="w-full mb-3">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className={`w-full h-12 px-4 py-3 bg-white/10 border ${errors.name ? 'border-red-500' : 'border-white/20'} rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all`}
                placeholder="Your Name *"
              />
              {errors.name && <p className="text-red-400 text-xs mt-1">{errors.name}</p>}
            </div>

            {/* Phone Field with Country Code */}
            <div className="w-full mb-3">
              <div className="flex">
                <select
                  name="countryCode"
                  value={formData.countryCode}
                  onChange={handleChange}
                  className="w-24 h-12 px-2 py-3 bg-white/10 border border-white/20 rounded-l-lg rounded-r-none border-r-0 text-white text-sm focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all"
                >
                  {countryCodes.map((country, idx) => (
                    <option key={idx} value={country.code} className="bg-gray-900">
                      {country.flag} {country.code}
                    </option>
                  ))}
                </select>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  className={`flex-1 w-full h-12 px-4 py-3 bg-white/10 border ${errors.phone ? 'border-red-500' : 'border-white/20'} rounded-r-lg rounded-l-none text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all`}
                  placeholder="Phone Number *"
                />
              </div>
              {errors.phone && <p className="text-red-400 text-xs mt-1">{errors.phone}</p>}
            </div>

            {/* Email Field */}
            <div className="w-full mb-3">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={`w-full h-12 px-4 py-3 bg-white/10 border ${errors.email ? 'border-red-500' : 'border-white/20'} rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all`}
                placeholder="Your Email *"
              />
              {errors.email && <p className="text-red-400 text-xs mt-1">{errors.email}</p>}
            </div>

            {/* Message Field */}
            <div className="w-full mb-3">
              <input
                type="text"
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                className={`w-full h-12 px-4 py-3 bg-white/10 border ${errors.message ? 'border-red-500' : 'border-white/20'} rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#168356] transition-all`}
                placeholder="Your Message *"
              />
              {errors.message && <p className="text-red-400 text-xs mt-1">{errors.message}</p>}
            </div>

            {/* Submit Button */}
            <div className="w-full">
              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full h-12 bg-gradient-to-r from-[#168356] to-[#0a5938] hover:from-[#0a5938] hover:to-[#168356] text-white font-bold px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#168356]/30 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? 'Submitting...' : (
                  <>
                    Start Registration <Send className="w-4 h-4 ml-2 inline" />
                  </>
                )}
              </Button>
            </div>
          </div>

          <p className="text-sm text-gray-400 text-center mt-4">
            No credit card required • Free consultation • Money-back guarantee
          </p>
        </form>
      </div>
    </div>
  );
};

export default CTASection;